import { render, staticRenderFns } from "./CaseTag.vue?vue&type=template&id=9af341c0"
import script from "./CaseTag.vue?vue&type=script&lang=js"
export * from "./CaseTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports